import { Avatar, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import {
  changeUserStatusApi,
  communityListUserApi,
  getUserDetailsApi,
} from "../../services/userManagement";
import toast from "react-hot-toast";
import Switch from "../../components/Switch/Switch";
import useButtonLoader from "../../hooks/UseButtonLoader";
import ModalBox from "../../components/modal/ModalBox";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import { RiCommunityLine } from "react-icons/ri";
import { dateFormat } from "../../components/Form";
import { Button } from "../../components/Button/Button";
import { catchMessage, elseMessage } from "../../comman/Message";

const ViewUserDetails = () => {
  const { id } = useParams();
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [userDetails, setUserDetails] = useState("");
  const [data, setData] = useState("");
  const [communityListUser, setCommunityListUse] = useState([]);
  const [total, setTotal] = useState(0);
  const [statusModal, setStatusModal] = useState(false);
  const [buttonref, buttonLoader] = useButtonLoader("Yes");

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //**********get user detail**********
  const getSingleUser = async () => {
    try {
      showLoader();
      const res = await getUserDetailsApi(id);
      hideLoader();
      if (res?.data?.status === 200) {
        setUserDetails(res?.data?.data?.userData);
        setData(res?.data?.data);
      } else {
        elseMessage(res);
        hideLoader();
      }
    } catch (err) {
      catchMessage(err);
      hideLoader();
    }
  };

  //--------------change-status-Product-------------------------
  const changeStatus = async () => {
    try {
      buttonLoader(true);
      let data = { status: !userDetails?.status, id: id };
      const res = await changeUserStatusApi(data);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        setStatusModal(false);
        buttonLoader(false);
        getSingleUser();
      } else {
        toast.error(res.data.message);
        buttonLoader(false);
      }
    } catch (e) {
      toast.error(e.message);
      buttonLoader(false);
    }
  };
  //--------------community-list-------this-user-create-community--------------
  const communityList = async (userId = id, page = activePage) => {
    setCommunityListUse([]);
    try {
      const res = await communityListUserApi({ userId, page });
      if (res?.data?.status === 200) {
        setCommunityListUse(res?.data?.data?.community || []); //remove 1
        setTotal(res.data.data.total || 0);
      } else {
        setCommunityListUse([]);
        toast.error(res?.data?.message);
      }
    } catch (err) {
      toast.error(err?.message);
    }
  };
  useEffect(() => {
    getSingleUser();
  }, []);
  useEffect(() => {
    communityList(id, activePage);
  }, [activePage]);
  return (
    <div className="WrapperArea">
      {loader}
      <div className="WrapperBox">
        <div className="row">
          <div className="col-10">
            <h4 className="Title">
              <Link to={-1}>
                <IconButton>
                  <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
                </IconButton>
              </Link>
              User Details
            </h4>
          </div>
          <div className="col-2 mt-2">
            {/* <Switch
                            checked={userDetails?.status}
                            onChange={() => setStatusModal(true)}
                        /> */}
            <Button onClick={() => setStatusModal(true)}>
              {userDetails?.status ? "Block User" : "Unblock User"}
            </Button>
          </div>
        </div>

        <div className="customer_details">
          <div className="innner">
            <div className="row">
              <div className="col-3">
                <Avatar
                  // variant="square"
                  // id={_id}
                  alt={"user"}
                  // src={imageUrl ? imageUrl[0] : null}
                  src={userDetails?.profile || userDetails?.profileUrl}
                  // role="button"
                  sx={{
                    height: 150,
                    width: 155,
                    // borderRadius: 10,
                  }}
                  // onClick={() => openImage(imageUrl)}
                />
              </div>
              <div className="col-9">
                <ul>
                  <li>
                    <strong>Name </strong>
                    <span>: {userDetails?.name || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Username </strong>
                    <span>: {userDetails?.userName || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Email </strong>
                    <span>: {userDetails?.email || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Mobile </strong>
                    <span>
                      :{" "}
                      {userDetails?.countryCode && userDetails?.mobile
                        ? `+${userDetails.countryCode} ${userDetails.mobile}`
                        : "N/A"}
                    </span>
                  </li>
                  <li>
                    <strong>Relation </strong>
                    <span>: {userDetails?.relation || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Born Year </strong>
                    <span>: {userDetails?.bornYear || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Country </strong>
                    <span>: {userDetails?.country?.name || "N/A"}</span>
                  </li>
                  <li>
                    <strong>State </strong>
                    <span>: {userDetails?.state?.name || "N/A"}</span>
                  </li>
                  <li>
                    <strong>City </strong>
                    <span>: {userDetails?.city?.name || "N/A"}</span>
                  </li>
                </ul>
              </div>

              <div className="col-12 mt-3">
                <h4>About</h4>
                <p className="lorem_text">
                  {userDetails?.about ||
                    "N/A"}{" "}
                </p>
              </div>

              <div className="col-12 mt-3">
                <ul>
                  <li>
                    <strong>User Type </strong>
                    <span>
                      :{" "}
                      {userDetails?.userType
                        ? userDetails.userType.charAt(0).toUpperCase() +
                          userDetails.userType.slice(1)
                        : "N/A"}
                    </span>
                  </li>
                  <li>
                    <strong>Business </strong>
                    <span>: {userDetails?.businessName || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Website</strong>
                    <span>
                      : <Link to="#">{userDetails?.businessUrl || "N/A"}</Link>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-3 mt-3">
                <p className="lorem_text text-center">
                  <span>{data?.activePlanPurchase?.plan?.type}</span>
                  <br />
                  <span>Subscription</span>
                </p>
              </div>
              <div className="col-3 mt-3">
                <p className="lorem_text text-center">
                  <span>{`$${data?.totaldonation||"0"}`}</span>
                  <br />
                  <span>Total Donated</span>
                </p>
              </div>
              <div className="col-3 mt-3">
                <p className="lorem_text text-center">
                  <span>{`$${data?.totalFundReceived||0}`}</span>
                  <br />
                  <span>Total Fund Received</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* ---------------listing-community--------------------- */}
        <h4 className="mt-4">My Created Community List</h4>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S. No.</th>
                {/* <th>Profile</th> */}
                <th>Community Name</th>
                <th>CreatedAt</th>
                <th>Community Type</th>
                {/* <th className="text-center"> Action </th> */}
              </tr>
            </thead>
            <tbody>
              {communityListUser.length > 0 ? (
                communityListUser.map(
                  ({ _id, communityName, createdAt, communityType }, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{++index + (activePage - 1) * 10}</td>
                          {/* <td>
                                                <div className="d-flex justify-content-center">
                                                    <Avatar
                                                        variant="square"
                                                        id={_id}
                                                        alt={productName}
                                                        // src={imageUrl ? imageUrl[0] : null}
                                                        src={imageUrl}
                                                        role="button"
                                                        sx={{
                                                            height: 35,
                                                            width: 35,
                                                            borderRadius: 10,
                                                        }}
                                                        onClick={() => openImage(imageUrl)}
                                                    />
                                                </div>
                                            </td> */}
                          <td>{communityName || "N/A"}</td>
                          <td>{dateFormat(createdAt)}</td>
                          <td>{communityType || "N/A"}</td>
                        </tr>
                      </React.Fragment>
                    );
                  }
                )
              ) : (
                <NotFound
                  cols={7}
                  msg="No community Found!"
                  icon={<RiCommunityLine style={{ fontSize: 48 }} />}
                  // loader={loader}
                />
              )}
            </tbody>
          </table>
        </div>
        {total >= 10 ? (
          <div className="Pagination">
            <Pagination
              previousLabel={"previous"}
              nextLabel={"next"}
              activePage={activePage}
              itemsCountPerPage={10}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              itemClass={"page-item"}
              linkClass={"page-link"}
            />
          </div>
        ) : null}
      </div>
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        // title="Change Status"
        title={`${userDetails?.status ? "Block" : "Unblock"} User`}
        description={
          <span>
            Do you want to {userDetails?.status ? "block" : "unblock"}{" "}
            <strong>{userDetails?.name}</strong> ?
          </span>
        }
        action={changeStatus}
        // ref={buttonref}
      />
    </div>
  );
};

export default ViewUserDetails;
